/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sci_result_solves = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solves for`)
};

const es_sci_result_solves = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula`)
};

const de_sci_result_solves = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löst nach`)
};

const nl_sci_result_solves = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berekent`)
};

const fr_sci_result_solves = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résout pour`)
};

const it_sci_result_solves = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risolve per`)
};

const pt_br2_sci_result_solves = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolve para`)
};

const pt_sci_result_solves = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolve para`)
};

const ja_sci_result_solves = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`計算対象`)
};

const zh_sci_result_solves = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`求解`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sci_result_solves = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sci_result_solves(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sci_result_solves", locale)
	if (locale === "en") return en_sci_result_solves(inputs)
	if (locale === "es") return es_sci_result_solves(inputs)
	if (locale === "de") return de_sci_result_solves(inputs)
	if (locale === "nl") return nl_sci_result_solves(inputs)
	if (locale === "fr") return fr_sci_result_solves(inputs)
	if (locale === "it") return it_sci_result_solves(inputs)
	if (locale === "pt-BR") return pt_br2_sci_result_solves(inputs)
	if (locale === "pt") return pt_sci_result_solves(inputs)
	if (locale === "ja") return ja_sci_result_solves(inputs)
	return zh_sci_result_solves(inputs)
};